var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-linear',{attrs:{"value":_vm.percentage*100,"height":"25"}},[_c('strong',[_vm._v(_vm._s(Math.ceil(_vm.percentage*100))+"% - "+_vm._s(_vm.message))])]),_c('terminal',{ref:"term",attrs:{"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }